<!-- <div
  id="chat_message_success_modal"
  class="fade in"
  role="dialog"
  style="display: block"
>
  <div class="modal-dialog" style="width: 310px">
    <div class="modal-content"> -->
<div class="modal-body modal-padding">
  <h5 [innerHtml]="message | sanitizeHtml"></h5>

  <div class="modal-footer">
    <button class="modal-button-style" (click)="closeDialog()">OK</button>
  </div>
</div>
<!-- </div>
  </div>
</div> -->
